import { routes } from '@/pages'
import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import clsx from 'clsx'
import { CircleAlert, X } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

export function AppOutdatedVersionBanner(): React.JSX.Element | null {
  const [isActive, setIsActive] = useState(true)

  return isActive ? (
    <div className={clsx('mt-6 mb-2 flex items-center justify-center rounded-lg p-4 shadow-md', 'bg-gray-100')}>
      <div className="m-auto flex items-center gap-2">
        <CircleAlert className="flex-shrink-0 text-[var(--color)]" />
        <Text className="max-tablet:whitespace-normal mx-2 text-center whitespace-pre-line">
          <Trans>
            One of your active devices is using an outdated version of the DataHive software and is not earning points.{' '}
            <Link
              to={routes.devices.path}
              className="cursor-pointer underline transition hover:text-[var(--colorHover)]"
            >
              Please check the ‘Devices’ section
            </Link>{' '}
            for more details.
          </Trans>
        </Text>
      </div>
      <button className="transition hover:text-[var(--colorHover)]" type="button" onClick={() => setIsActive(false)}>
        <X height={12} width={12} />
      </button>
    </div>
  ) : null
}
